import { ProgrammesHero, ProgrammesList, ProgrammeApproach } from '@/components/sections/programmes'
import { FinalCTA } from '@/components/sections'
import { usePageTitle } from '@/hooks'

export const ProgrammesPage = () => {
  usePageTitle('Programmes')

  return (
    <>
      <ProgrammesHero />
      <ProgrammesList />
      <ProgrammeApproach />
      <FinalCTA />
    </>
  )
}
